export class ApxError extends Error {
    constructor(message: string) {
        super(`ApxError: ${message}`);
    }
}
